import NextStepButton from '../../../Components/NextStepButton';
import { StepperNavigationButtons } from '../../../Components/StepperNavigationButtons';
import StepProps from '../../StepProps';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';

interface IdentifyExperienceStepNavigationProps extends Omit<StepProps, 'handleNext'> {
    experienceCriteriaProcessingState: ProcessingState;
    processingState: ProcessingState;
    isEditMode: boolean;
}

function IdentifyExperienceStepNavigation({
    activeStep,
    handleBack,
    experienceCriteriaProcessingState,
    processingState,
    isEditMode,
}: IdentifyExperienceStepNavigationProps) {
    return (
        <StepperNavigationButtons
            activeStep={activeStep}
            handleBack={handleBack}
            nextButtonComponent={
                <NextStepButton
                    disabled={experienceCriteriaProcessingState === ProcessingState.Processing}
                    loading={processingState === ProcessingState.Processing}
                >
                    {isEditMode ? UIStrings.Update : UIStrings.CreateRecruitment}
                </NextStepButton>
            }
            processingState={processingState}
        />
    );
}

export default IdentifyExperienceStepNavigation;
